module.exports = __webpack_public_path__ + "static/media/3D打印动力小车.9908791a.png";